<template>
    <div class="account-page">
        <!-- Main Wrapper -->
		<div class="main-wrapper">
		
			<!-- Header -->
                    <layout-header />
			<!-- /Header -->
			
			<!-- Page Content -->
			<div class="content">
				<div class="container-fluid">
					
					<div class="row">
						<div class="col-md-8 offset-md-2">
							
							<!-- Account Content -->
							<div class="account-content">
								<div class="row align-items-center justify-content-center">
									<div class="col-md-7 col-lg-6 login-left">
										<img src="@/assets/img/login-banner.png" class="img-fluid" alt="Login Banner">	
									</div>
									<div class="col-md-12 col-lg-6 login-right">
										<div class="login-header">
											<h3>Reset Password?</h3>
											<p class="small text-muted">Silahkan Masukkan password baru anda</p>
										</div>
										
										<!-- Forgot Password Form -->
										
                    <div v-if="isSuccess">
                      <div class="alert alert-warning" v-if="msg">
                        {{ msg }}
                      </div>											
                      <router-link to="/login" class="btn btn-primary btn-block btn-lg login-btn" >Login</router-link>
                    </div>

										<div class="alert alert-danger" v-if="errors">
											{{ errors }}
										</div>
										<form @submit.prevent="resetPassword" v-if="!isSuccess">
											<div class="form-group form-focus">
												<input type="password" class="form-control floating" v-model="form.password" >
												<label class="focus-label">Password</label>
											</div>
											<div class="text-right">
												<router-link class="forgot-link" to="/login">Login?</router-link>
											</div>
											<button class="btn btn-primary btn-block btn-lg login-btn" type="submit">Reset Password</button>
										</form>
										<!-- /Forgot Password Form -->
										
									</div>
								</div>
							</div>
							<!-- /Account Content -->
							
						</div>
					</div>

				</div>

			</div>		
			<!-- /Page Content -->
   
			<!-- Footer -->
                <layout-footer />
			<!-- /Footer -->
		   
		</div>
		<!-- /Main Wrapper -->
    </div>
</template>

<script>  

import Util from '../../../assets/utils/utils'
import {mapGetters} from 'vuex'

import axios from 'axios';

  export default {  
    data(){
      return {
        form: {
          verification_key: '',
          password: '',
        },
        isSuccess: false,
        errors: null,
        msg: null
      }
    },
    computed: {
        ...mapGetters({ 
            isLoggedIn: 'isLoggedIn',
            user: 'user',
        }),
        currentPath() {
            return this.$route.name
        }
    },
    created:function () {
      if(this.user){
        if(this.user.hak_akses == '1')
          this.$router.push({name: 'siswa-profile-settings'})
        else if(this.user.hak_akses == '2')
          this.$router.push({name: 'instructor-profile-settings'})
        else if(this.user.hak_akses == '3')
          this.$router.push({name: 'admin-profile-settings'})
      } else {
        
        const verification_key = this.$route.query.vkey;
        this.form.verification_key = verification_key;
        // console.log(idcat);
      }
        
    },
    methods: {
		
        resetPassword: function () {
          axios.post('resetPassword', {
                    verification_key: this.form.verification_key,
                    password: this.form.password
                })
                .then(res => {
                  this.isSuccess = true;
                  this.form.password = '';
					        this.msg = res.data.message;
                })
                .catch(err => {
                    // handle error
                  console.log(err);
        			    this.errors = err.data.message;
                })
        },
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Pages/ResetPassword/index.vue